<template>
  <router-link
    :is="premiumRestriction ? 'span' : 'router-link'"
    :to="!premiumRestriction ? route : ''"
    class="gc"
    :class="{anchor: isAnchor, 'gc-locked': premiumRestriction, 'premium-lock': premiumRestriction}"
    tabindex="-1">
    <div
      @click.prevent="handleInteraction"
      @keydown="handleInteraction"
      role="link"
      :tabindex="premiumRestriction ? -1 : 0"
      :aria-disabled="premiumRestriction">
      <div class="main">
        <slot />
      </div>
      <div class="middle">
        <slot name="middle" />
      </div>
      <div class="footer">
        <slot name="footer" />
      </div>
    </div>

    <span v-if="premiumRestriction" class="label label-danger label--footer"><i class="fa fa-lock"/> PREMIUM</span>
  </router-link>
</template>

<script>
import {
  RestrictionTypePremium,
  restrictionValidator
} from '../browse_goal_card_restrictions'

export default {
  name: 'GoalCardShell',
  props: {
    route: {
      type: Object,
      required: true
    },
    isAnchor: {
      type: Boolean,
      default: true
    },
    restrictionType: {
      type: String,
      default: '',
      validator: restrictionValidator
    }
  },
  computed: {
    premiumRestriction() {
      return this.restrictionType === RestrictionTypePremium
    }
  },
  methods: {
    handleInteraction(e) {
      if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
        if (e.key === ' ') {
          e.preventDefault();
        }
        this.$emit('click', e);
        if (!this.premiumRestriction) {
          this.$router.push(this.route);
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/mixins.less';
@import '~@/variables.less';
@import './colors.less';

.gc {
  .paper-card;
  display: block;
  position: relative;
  text-decoration: none;
  background: @legacyBackground;

  &.anchor {
    background: @anchorBackground;
  }

  &:hover {
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.5);
    text-decoration: none;
    /deep/ h3 {
      color: @link-hover-color;
    }
  }

  .main,
  .middle,
  .footer {
    padding: 20px 20px;
  }

  .main {
    padding-bottom: 0px;
    height: 171px;
    overflow: hidden;
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
  }
  .middle {
    font-size: 10px;
    font-weight: bold;
  }
  .footer {
    padding: 12px 20px;
    background: @footerBackground;
    border-bottom-right-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  &.gc-locked {
    .main,
    .middle,
    .footer {
      opacity: 1;
    }
  }

  &.premium-lock {
    cursor: not-allowed;
    /deep/ h3, /deep/ p, /deep/ div {
      color: transparent;
    }
    /deep/ h3, /deep/ p, /deep/ span, /deep/ div,  {
      cursor: not-allowed;
    }
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.26);
  }
}
.label-info {
  background: @label-info-bg;
}
.label-success {
  background: @label-success-bg;
}
.label-danger {
  background: @label-danger-bg;
}
.label--footer {
  position: absolute;
  right: 12px;
  bottom: 10px;
  font-size: 13px;
}
</style>
